import tenantApi from '../clients/tenant-api';

export const generateTenantSearchKey = async (): Promise<string> => {
  const { data } = await tenantApi.post<string>('/generate-search-key');

  return data;
};
